// Workspace URL helpers (T2 routing, cross-screen-overview-and-live-share.md §2.3).
// Every internal destination is /workspace/{companySlug}/{screenSlug}. Callers
// pass the state snapshot they already hold (useWorkspace() result or
// dataClient.peek()) so the helpers stay pure and deterministic.

// The company slug in URLs. Post-T1 every PB business has a unique slug and the
// demo business ships one too — 'workspace' is only the pre-auth/unknown
// placeholder (see viewerSession.js resolveWorkspaceRedirect).
export function businessSlugFrom(state) {
  return state?.business?.slug || 'workspace';
}

export function workspacePath(screenSlug, state) {
  return `/workspace/${businessSlugFrom(state)}/${screenSlug}`;
}

export function homePath(state) {
  return workspacePath('headquarters', state);
}
